import { SchemaType } from '../type';
export const schema = {
    id: 'collection',
    name: '数据源',
    identityField: 'name',
    type: SchemaType.Indivisible,
};
